<div class="driver">
  @if (showNotFoundContent()) {
  <h3 id="status-driver-info">
    {{ "remote-experience.information-service.title." + modality() | lowercase | translate }}
  </h3>
  }

  <div class="driver__wrapper">
    @if ((driverData$ | async)?.response; as driver) {
      <img [src]="imageSignal()" alt="Driver" />
      <div class="driver__wrapper__content">
        @if (modality() === modalityEnum.PDL) {
        <h4 id="driver">
          {{ driver.advisorDriverName | titlecase }}
        </h4>

        <p>{{ "schedule.pickup-schedule" | translate }}</p>
        <span class="driver__wrapper__content__delivery-info" id="driver-date-hour">
          {{ driver.dateAndHour }}
        </span>
        }

        @if (modality() === modalityEnum.MSV) {
        <div class="driver__wrapper__content__remote-experience">
          <div>
            <h4>{{'remote-experience.information-service.driver.title' | translate}}</h4>
            <p id="advisor-name">{{driver.advisorDriverName}}</p>
          </div>
          <div>
            <h4>{{'remote-experience.information-service.driver.subtitle' | translate}}</h4>
            <p id="vehicle-remote-model">{{driver.vehicleModel}}</p>
            <p id="vehicle-remote-plate">{{driver.vehiclePlate}}</p>
          </div>
        </div>
        }
      </div>
    } @else {
      @if (loadingDriver()) {
      <agenda-customer-ui-driver-loading [modalitySchedule]="modality()" />
      } @else {
        @if (showNotFoundContent()) {
        <img [src]="imageSignal()" alt="Driver" />
        <div class="driver__wrapper__content">
          <span class="driver__wrapper__content__no-name" id="driverWithout">
            {{ "remote-experience.information-service.without-driver." + modality() | lowercase | translate }}
          </span>

          @if (modality() === modalityEnum.PDL) {
          <p class="driver__wrapper__content__text">{{ "schedule.pickup-schedule" | translate }}</p>
          <span class="driver__wrapper__content__delivery-info" id="status-date-hour-confirm">
            {{ "dashboard.schedule.no-pud-hour" | translate }}
          </span>
          }
        </div>
        }
      }
    }
  </div>
</div>
